import {
  accountDescription,
  assetDescription,
  buildEntityDescriptions,
  clearwaterTransactionDescription,
  declareCommentaryContext,
  describeEntity,
  transactionLinkId,
} from '@helios/comments'
import { ClearwaterTransaction } from '@helios/common-api'

export const clearwaterTransactionCommentary =
  declareCommentaryContext<ClearwaterTransaction>()({
    fields: [
      'accountId',
      'accountName',
      'legacyOrigId',
      'secIdentifier',
      'tranTypeCode',
      'amount',
      'units',
      'entryDate',
      'tradeDate',
    ],
    build: tx => {
      const transactionId = transactionLinkId(tx.legacyOrigId)
      return {
        accountId: tx.accountId?.toString(),
        transactionId,
        assetId: tx.secIdentifier,
        entityDescriptions: buildEntityDescriptions([
          describeEntity(
            'account',
            tx.accountId,
            accountDescription({ accountName: tx.accountName }),
          ),
          describeEntity(
            'tran',
            transactionId,
            clearwaterTransactionDescription({
              tranTypeCode: tx.tranTypeCode,
              amount: tx.amount,
              units: tx.units,
              entryDate: tx.entryDate,
              tradeDate: tx.tradeDate,
              secIdentifier: tx.secIdentifier,
            }),
          ),
          describeEntity(
            'asset',
            tx.secIdentifier,
            assetDescription({ secIdentifier: tx.secIdentifier }),
          ),
        ]),
      }
    },
  })
